export const SET = 'Analysis/data/columns/SET';

export function setColumns(columns) {
  return {
    type: SET,
    columns
  }
}